import { Caption1, Card, CardHeader, CardPreview, Text } from '@fluentui/react-components'
import React from 'react'

type FluentCardProps = {
  title?: string
  description?: string
  icon?: JSX.Element
  action?: JSX.Element
  style?: React.CSSProperties // Allow passing styles
  children?: React.ReactNode // Add children to FluentCardProps
}

export const FluentCard: React.FC<FluentCardProps> = (props) => {
  return (
    <Card
      orientation="horizontal"
      style={{
        width: '100%',
        maxWidth: '100%',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
        border: '1px solid #ddd',
        borderRadius: '8px',
        ...props.style, // Allow override
      }}
    >
      <CardPreview style={{ padding: '10px' }}>{props.icon}</CardPreview>
      <CardHeader
        header={<Text weight="semibold">{props.title}</Text>}
        description={<Caption1>{props.description}</Caption1>}
        action={props.action}
      />
      {props.children && <div style={{ marginTop: '10px' }}>{props.children}</div>}
    </Card>
  )
}
